import React from "react";
import { useNavigate } from "react-router-dom";
import placeholderImage from "../assets/images/hero-image.png";

/**
 * Hero Component
 * - Full-width, 78-82vh height
 * - Centered content with heading and CTA
 * - Background image with overlay
 * - Entrance animations
 */
function Hero() {
  const navigate = useNavigate();

  const handleMenuClick = () => {
    navigate("/menu");
  };

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden"
      style={{ height: "80vh", minHeight: "600px" }}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${placeholderImage})`,
        }}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto animate__animated animate__fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: "'Sour Gummy', cursive" }}
          >
            100% Authentic Haitian Cuisine
          </h1>
          <p className="text-lg sm:text-xl text-white/90 mb-8">
            Proudly serving Newark, NJ!
          </p>
          <button
            onClick={handleMenuClick}
            className="text-white px-8 py-3 sm:px-10 sm:py-4 rounded-lg font-semibold text-base sm:text-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
            style={{ backgroundColor: "#f2340a" }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "#d91f00")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "#f2340a")
            }
          >
            VIEW OUR MENU
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
